import { React, useState } from 'react'
import { Container, Navbar, Nav, NavDropdown } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import { IoMdSettings } from 'react-icons/io'
import Popup from './Popup'
import SelectToken from './SelectToken'
import TransactionFailed from './TransactionFailed'
import TransactionSuccess from './TransactionSuccess'
import TransactionProgress from './TransactionProgress'
import RecievePopup from './RecievePopup'
import Information from './Information'
import StakeYrpToken from './StakeYrpToken'
import WithdrawYrp from './WithdrawYrp'
import CompoundYrp from './CompoundYrp'
export default function Header() {

    const [expanded, setExpanded] = useState(false);
    const location = useLocation();
    let path = location.pathname;

    const [state, setstate] = useState(0)


    return (
        <>

            {state == 1 && <Popup passState={setstate} />}
            {/* {state == 1 && <SelectToken passState={setstate} />} */}
            {/* {state == 1 && <TransactionFailed passState={setstate} />} */}
            {/* {state == 1 && <TransactionSuccess passState={setstate} />} */}
            {/* {state == 1 && <TransactionProgress passState={setstate} />} */}
            {/* {state == 1 && <Information passState={setstate} />} */}
            {/* {state == 1 && <StakeYrpToken passState={setstate} />} */}
            {/* {state == 1 && <WithdrawYrp passState={setstate} />} */}
            {/* {state == 1 && <CompoundYrp passState={setstate} />} */}

            <Navbar variant="dark" expand="lg" expanded={expanded}>
                <Container>
                    {/* show on mobil  */}
                    <div className="d-lg-none d-md-flex  d-none">
                        <span className='wallet-mobile ' >
                            <img src={process.env.PUBLIC_URL + "assets/images/wallet.png"}  onClick={() => { setstate(1) }}/>
                        </span>
                        <span class="g-btn me-2 ms-2 px-1" style={{ minWidth: '70px' }}> <span className="">999.99$</span> </span>

                    </div>
                    {/* 1 */}

                    <div className="d-lg-none d-md-none align-items-center d-flex" >
                        <span className='wallet-mobile'>
                            <img src={process.env.PUBLIC_URL + "assets/images/wallet.png"}  onClick={() => { setstate(1) }}/>
                        </span>
                        <span class="g-btn me-2   d-flex  px-1 ms-3" style={{ minWidth: '70px' }}> 999.99$ </span>
                    </div>
                    {/*  1*/}


                    <Link className="navbar-brand d-lg-none d-block" to="/"><img src={process.env.PUBLIC_URL + '/assets/images/logo.png'} alt="" /></Link>



                    {/* <button className="g-btn  d-lg-none d-md-flex  d-none me-2 px-4" onClick={() => { setstate(1) }}><img src={process.env.PUBLIC_URL + "assets/images/wallet.png"} /> </button> */}

                    <div className="d-flex align-items-center">
                        <div className=" d-lg-none  d-flex me-3">
                            <NavDropdown className="flag-select-parent" title={<><img src={process.env.PUBLIC_URL + "assets/images/binance-transparent.png"} className="flag-selece-2" /> </>} id="basic-nav-dropdown" >
                                <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                                <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
                                <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
                            </NavDropdown>
                        </div>

                        <div className="d-flex ">
                            <div className="d-lg-none d-flex align-items-center">
                                <NavDropdown variant="secondary" className="flag-select-parent" title={<img src={process.env.PUBLIC_URL + "assets/images/united-kingdom.png"} className="flag-selece" />} id="basic-nav-dropdown">
                                    <NavDropdown.Item href="#action/3.1">English</NavDropdown.Item>
                                    <NavDropdown.Item href="#action/3.2">French</NavDropdown.Item>
                                    <NavDropdown.Item href="#action/3.3">Arabic</NavDropdown.Item>
                                </NavDropdown>
                            </div>

                            <Navbar.Toggle onClick={() => { expanded ? setExpanded(false) : setExpanded(true) }} aria-controls="basic-navbar-nav" />
                        </div>
                    </div>




                    <Navbar.Collapse id="basic-navbar-nav">
                        <div className="d-flex align-items-center justify-content-lg-start justify-content-between ">
                            <button className="g-btn d-lg-flex d-none px-4" onClick={() => { setstate(1) }}>Connect </button>
                            <div className="d-lg-flex d-none">
                                <NavDropdown variant="secondary" className="flag-select-parent" title={<img src={process.env.PUBLIC_URL + "assets/images/united-kingdom.png"} className="flag-selece" />} id="basic-nav-dropdown">
                                    <NavDropdown.Item href="#action/3.1">English</NavDropdown.Item>
                                    <NavDropdown.Item href="#action/3.2">French</NavDropdown.Item>
                                    <NavDropdown.Item href="#action/3.3">Arabic</NavDropdown.Item>
                                </NavDropdown>
                            </div>
                        </div>
                        <Nav className="">
                            {/* <div className="d-md-none d-flex pb-3 align-item-center justify-content-between">
                                <span class="g-btn me-2 px-1"> <span className="">999.99$</span> </span>
                                <button className="g-btn px-4" onClick={() => { setstate(1) }}><img src={process.env.PUBLIC_URL + "assets/images/wallet.png"} /> </button>
                            </div> */}
                            <Link onClick={() => { setExpanded(false) }} className={path == '/' ? "nav-link active" : " nav-link "} to="/">Home</Link>
                            <Link onClick={() => { setExpanded(false) }} className={path == '/swap' ? "nav-link active" : " nav-link "} to="/swap">Swap</Link>
                            <Link onClick={() => { setExpanded(false) }} className={path == '/liquidity' || path == '/find-liquidity' || path == '/add-liquidity' || path == '/remove-liquidity' ? "nav-link active" : " nav-link "} to="/liquidity">Liquidity</Link>
                            <Link onClick={() => { setExpanded(false) }} className={path == '/stake' ? "nav-link active" : " nav-link "} to="/stake">Stake</Link>
                            <Link onClick={() => { setExpanded(false) }} className="navbar-brand d-lg-block d-none" to="/"><img src={process.env.PUBLIC_URL + '/assets/images/logo.png'} alt="" /></Link>
                            <Link onClick={() => { setExpanded(false) }} className={path == '/farms' ? "nav-link active" : " nav-link "} to="/farms">Farms</Link>
                            <Link onClick={() => { setExpanded(false) }} className={path == '/treasury' ? "nav-link active" : " nav-link "} to="/treasury">Treasury</Link>
                            <Link onClick={() => { setExpanded(false) }} className={path == '/iro' ? "nav-link active" : " nav-link "} to="/iro">IRO</Link>
                            <Link onClick={() => { setExpanded(false) }} className={path == '/rewards' ? "nav-link active" : " nav-link "} to="/rewards">Rewards</Link>
                        </Nav>
                        <div className="d-flex align-items-lg-center align-items-start flex-lg-row flex-column ">
                            <div className="d-lg-block d-none">
                                <NavDropdown className="flag-select-parent" title={<><img src={process.env.PUBLIC_URL + "assets/images/chain.png"} className="flag-selece-2" /> </>} id="basic-nav-dropdown" >
                                    <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                                    <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
                                    <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
                                </NavDropdown>
                            </div>

                            <span class="g-btn d-lg-flex d-none px-1"><span className="">999.99$</span> </span>
                            {/* <div className="d-flex align-items-center w-100">
                                <div className="px-2">
                                    <IoMdSettings className="setting-icons" />
                                </div>
                            </div> */}

                        </div>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    )
}
